import { type ActionItem, DividerCustom } from 'shared/ui'
import { SwitchAction } from 'shared/ui/SwitchAction'
import { logger } from 'shared/lib'
import { type Campaign, CampaignApi } from 'entities/Campaign'
import { CampaignEnrolmentStore } from 'pages/campaigns/ui/CampaignEnrolment'
import { openDisableCampaignModal } from './openDisableCampaignModal'

export const toggleActiveCampaign = (campaign: Campaign): ActionItem => {
  const onDisabled = () => {
    openDisableCampaignModal(campaign.id, (data) => {
      campaign.syncOrigin(data)
    })
  }

  const onActivate = async () => {
    try {
      const { data } = await CampaignApi.patch(campaign.id, {
        status: 'active',
      })
      campaign.syncOrigin(data.data)

      const campaignEnrolmentStore = new CampaignEnrolmentStore()
      await campaignEnrolmentStore.init({
        data: {
          name: data.data.name,
          id: data.data.id,
          filters: data.data.filters,
        },
      })
    } catch (e) {
      logger.error(e)
    }
  }

  const handleToggle = async (onCloseMenu?: () => void) => {
    if (campaign.status === 'active') {
      onCloseMenu?.()
      onDisabled()
    }
    if (campaign.status === 'disabled') {
      await onActivate()
      onCloseMenu?.()
    }
  }
  return {
    dropdownItemComponent: (onCloseMenu) => (
      <>
        <SwitchAction
          size={'xSmall'}
          active={campaign.status === 'active'}
          onTrigger={() => handleToggle(onCloseMenu)}
          label={campaign.status === 'active' ? 'Active' : 'Disabled'}
        />
        <DividerCustom variant={'dropdown'} />
      </>
    ),
    buttonComponent: (
      <SwitchAction
        active={campaign.status === 'active'}
        onTrigger={() => handleToggle()}
        size={'middle'}
      />
    ),
  }
}
